import React from "react";
//====================================================================
import { types, Image } from "react-bricks/frontend";
import TextBlock from "../common/TextBlock";
import { color } from "@styles";
import { textColorProp } from "../utils/colorPickerProps";
import styled from "styled-components";

interface ChecklistItemProps {
  value: types.TextValue;
  textColor?: string;
}

const ChecklistItem: types.Brick<ChecklistItemProps> = ({ textColor }) => {
  return (
    <TextWrap>
      <ImageContainer>
        <Image propName="icon" alt="check" />
      </ImageContainer>
      <TextContent>
        <TextBlock
          propName="text"
          color={textColor || color.B1100}
          placeholder="Type a placeholder..."
          renderPlaceholder={({ children }) => <div>{children}</div>}
        />
      </TextContent>
    </TextWrap>
  );
};

ChecklistItem.schema = {
  // Unique brick name
  name: "checklist-item",
  label: "Checklist Item",
  hideFromAddMenu: true,
  // Defaults when a new brick is added
  getDefaultProps: () => ({
    value: "Thick as a brick",
    textColor: color.B1100,
    icon: {
      src: "/static/icons/Check.svg",
      alt: "check",
      meta: {},
    },
  }),

  // Sidebar Edit controls for props
  sideEditProps: [
    textColorProp,
    {
      name: "icon",
      label: "Icon",
      type: types.SideEditPropType.Image,
      shouldRefreshStyles: true,
    },
  ],
};

export default ChecklistItem;

const TextWrap = styled.li`
  display: flex;
  gap: 1rem;
  letter-spacing: 0.029rem;
  margin: 0.3rem 1rem 1.2rem 0.3rem;
`;

const ImageContainer = styled.div`
  height: 1.5rem;
  width: 1.5rem;
`;

const TextContent = styled.div`
  max-width: 30rem;
`;
